import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import { SupplierReportItem } from '@/features/slice/report';
import { formatCurrencyInBDT } from '@/utils';

export const supplierReportColumns: ColumnDef<SupplierReportItem>[] = [
    {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => <span>{row.original.name}</span>,
    },

    {
        accessorKey: 'phone_number',
        header: 'Phone Number',
        cell: ({ row }) => <span>{row.original.phone_number}</span>,
    },
    {
        accessorKey: 'email',
        header: 'Email',
        cell: ({ row }) => <span>{row.original.email}</span>,
    },
    {
        accessorKey: 'created_at',
        header: () => <div className={'text-center'}>Supplier Since</div>,
        cell: ({ row }) => (
            <span className={'block text-center'}>
                {format(row.original.created_at, 'dd-MM-yyyy')}
            </span>
        ),
    },

    {
        accessorKey: 'total_purchases',
        header: () => (
            <span className={'block text-right font-medium'}>Total Orders</span>
        ),
        cell: ({ row }) => (
            <span className={'block text-right'}>
                {row.original.total_purchases}
            </span>
        ),
    },
    {
        accessorKey: 'total_price',
        header: () => (
            <span className={'block text-right font-medium'}>Total Price</span>
        ),
        cell: ({ row }) => (
            <span className={'block text-right'}>
                {formatCurrencyInBDT(row.original.total_price)}
            </span>
        ),
    },
    {
        accessorKey: 'total_paid',
        header: () => (
            <span className={'block text-right font-medium'}>Total Paid</span>
        ),
        cell: ({ row }) => (
            <span className={'block text-right'}>
                {formatCurrencyInBDT(row.original.total_paid)}
            </span>
        ),
    },
    {
        accessorKey: 'total_due',
        header: () => (
            <span className={'block text-right font-medium'}>Total Due</span>
        ),
        cell: ({ row }) => (
            <span className={'block text-right'}>
                {formatCurrencyInBDT(row.original.total_due)}
            </span>
        ),
    },

    {
        accessorKey: 'last_purchase_date',
        header: () => (
            <span className={'block text-center'}>Last Purchase Date</span>
        ),
        cell: ({ row }) => (
            <span className={'block text-center'}>
                {row.original.last_purchase_date
                    ? format(
                          new Date(row.original.last_purchase_date),
                          'dd-MM-yyyy',
                      )
                    : '---'}
            </span>
        ),
    },
];
